module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "md-body-2",
    domProps: {
      "innerHTML": _vm._s(_vm.question.q.en)
    }
  }), _vm._v(" "), (_vm.question.a) ? _c('div', {
    staticStyle: {
      "display": "flex",
      "justify-content": "space-between",
      "align-items": "center"
    }
  }, [(_vm.question.a.type == 'check') ? _c('div', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('md-checkbox', {
    staticClass: "md-primary",
    attrs: {
      "name": _vm.question.id
    },
    model: {
      value: (_vm.v),
      callback: function($$v) {
        _vm.v = $$v
      },
      expression: "v"
    }
  }, [_vm._v(_vm._s(_vm.question.a.value.en))])], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'boolean') ? _c('div', [_c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "padding-right": "16px"
    },
    attrs: {
      "name": _vm.question.id,
      "md-value": "false"
    },
    model: {
      value: (_vm.v),
      callback: function($$v) {
        _vm.v = $$v
      },
      expression: "v"
    }
  }, [_vm._v("No")]), _vm._v(" "), _c('md-radio', {
    staticClass: "md-primary",
    staticStyle: {
      "padding-right": "16px"
    },
    attrs: {
      "name": _vm.question.id,
      "md-value": "true"
    },
    model: {
      value: (_vm.v),
      callback: function($$v) {
        _vm.v = $$v
      },
      expression: "v"
    }
  }, [_vm._v("Yes")])], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'number') ? _c('div', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "type": "number",
      "placeholder": _vm.question.a.placeholder
    },
    model: {
      value: (_vm.v),
      callback: function($$v) {
        _vm.v = $$v
      },
      expression: "v"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'text') ? _c('div', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('md-input-container', [_c('md-input', {
    attrs: {
      "placeholder": _vm.question.a.placeholder
    },
    model: {
      value: (_vm.v),
      callback: function($$v) {
        _vm.v = $$v
      },
      expression: "v"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'date') ? _c('div', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [_c('date-picker', {
    staticStyle: {
      "margin": "4px 0px 24px 0px"
    },
    attrs: {
      "date": _vm.date,
      "option": _vm.datePickerOption
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'array') ? _c('div', {
    staticStyle: {
      "flex-grow": "2"
    }
  }, [(_vm.question.a.max == 1 && _vm.question.a.display == 'radio') ? _c('div', _vm._l((_vm.array), function(item, i) {
    return _c('md-radio', {
      key: i,
      staticClass: "md-primary",
      staticStyle: {
        "padding-right": "16px"
      },
      attrs: {
        "name": _vm.question.id,
        "md-value": i + 1
      },
      model: {
        value: (_vm.vcheckbox),
        callback: function($$v) {
          _vm.vcheckbox = _vm._n($$v)
        },
        expression: "vcheckbox"
      }
    }, [_vm._v(_vm._s(item.en))])
  }), 1) : (_vm.question.a.max == 1) ? _c('div', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.v),
      expression: "v"
    }],
    staticClass: "mdc-select",
    attrs: {
      "size": "1"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.v = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.array), function(item, i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v(_vm._s(item.en))])
  })], 2)]) : _c('div', _vm._l((_vm.array), function(item, i) {
    return _c('div', [_c('div', {
      staticClass: "md-checkbox md-primary",
      class: {
        'md-checked': _vm.varray.indexOf(i) >= 0
      },
      staticStyle: {
        "margin": "8px 0px"
      }
    }, [_c('div', {
      staticClass: "md-checkbox-container",
      staticStyle: {
        "min-width": "20px"
      },
      on: {
        "click": function($event) {
          return _vm.onClickCheck(i)
        }
      }
    }, [_c('input', {
      attrs: {
        "type": "checkbox",
        "name": _vm.question.id
      }
    }), _vm._v(" "), _vm._m(0, true)]), _vm._v(" "), _c('label', {
      staticClass: "md-checkbox-label",
      staticStyle: {
        "height": "auto"
      },
      attrs: {
        "for": _vm.question.id
      }
    }, [_vm._v(_vm._s(item.en))])])])
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.question.a.type == 'arraycomplete') ? _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.v),
      expression: "v"
    }],
    attrs: {
      "list": _vm.question.id,
      "type": "search"
    },
    domProps: {
      "value": (_vm.v)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.v = $event.target.value
      }
    }
  }), _vm._v(" "), _c('datalist', {
    attrs: {
      "id": _vm.question.id
    }
  }, _vm._l((_vm.array), function(item, i) {
    return _c('option', {
      key: i,
      domProps: {
        "value": item.en
      }
    })
  }), 0)]) : _vm._e(), _vm._v(" "), (_vm.question.info) ? _c('div', {
    staticStyle: {
      "margin-left": "16px"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button",
    on: {
      "click": function($event) {
        _vm.viewInfo = !_vm.viewInfo
      }
    }
  }, [_c('md-icon', {
    staticStyle: {
      "width": "10px",
      "color": "#FF5722"
    }
  }, [_vm._v("help_outline")])], 1)], 1) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.viewInfo && _vm.question.info) ? _c('div', {
    staticStyle: {
      "padding": "8px 16px 8px 0px"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.question.info.en)
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.hasError) ? _c('div', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.err()))]) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "md-ink-ripple"
  }, [_c('div', {
    staticClass: "md-ripple",
    staticStyle: {
      "width": "20px",
      "height": "20px"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f10bac4","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Question.vue
// module id = 730
// module chunks = 3